import { DateTime } from 'luxon';
import {
	FlightPartyComposition,
	RoomComposition
} from '../lib/utils/composition.service';
import { Airport, Location, Gateway } from './api';

export enum PRODUCT_TYPES {
	FLIGHT_ONLY = 'FLIGHT_ONLY',
	REWARD_FLIGHT = 'REWARD_FLIGHT',
	FLIGHT_HOTEL = 'FLIGHT_HOTEL',
	FLIGHT_CAR = 'FLIGHT_CAR',
	PACKAGES = 'PACKAGES',
	HOLIDAY = 'HOLIDAY',
	HOTEL = 'HOTEL',
	MULTICENTRE = 'MULTICENTRE',
	FLYDRIVE = 'FLYDRIVE',
	CAR = 'CAR'
}

export type Criteria =
	| FLIGHT_ONLY
	| REWARD_FLIGHT
	| FLIGHT_HOTEL
	| HOLIDAY
	| HOTEL
	| MULTICENTRE
	| FLYDRIVE
	| CAR;

export interface BaseCriteria {
	refs?: { [key: string]: string };
}

export interface FLIGHT_ONLY extends BaseCriteria {
	searchType: PRODUCT_TYPES.FLIGHT_ONLY | PRODUCT_TYPES.REWARD_FLIGHT;
	origin?: Airport[];
	destination?: Airport[];
	departing?: DateTime[];
	passengers?: FlightPartyComposition;
	discountCode?: string;
	cabin?: string;
	paymentType?: string;
	tripType?: string;
}

export interface REWARD_FLIGHT extends FLIGHT_ONLY {
	searchType: PRODUCT_TYPES.REWARD_FLIGHT;
}

export interface CJS_GENERIC extends BaseCriteria {
	searchType?: string;
	location?: Location;
	departureDate?: DateTime;
}

export interface HOTEL extends CJS_GENERIC {
	searchType: PRODUCT_TYPES.HOTEL;
	duration?: number;
	rooms?: RoomComposition[];
}

export interface FLIGHT_HOTEL extends CJS_GENERIC {
	searchType: PRODUCT_TYPES.FLIGHT_HOTEL;
	gateways?: Gateway[];
	gateway?: Gateway;
	duration?: number;
	rooms?: RoomComposition[];
}

export interface HOLIDAY extends CJS_GENERIC {
	searchType: PRODUCT_TYPES.HOLIDAY;
	gateways?: Gateway[];
	gateway?: Gateway;
	duration?: number;
	rooms?: RoomComposition[];
}

export interface MULTICENTRE extends CJS_GENERIC {
	searchType: PRODUCT_TYPES.MULTICENTRE;
	rooms?: RoomComposition[];
}

export interface FLYDRIVE extends CJS_GENERIC {
	searchType: PRODUCT_TYPES.FLYDRIVE;
	gateways?: Gateway[];
	gateway?: Gateway;
	duration?: number;
	passengers?: RoomComposition[];
}

export interface CAR extends BaseCriteria {
	searchType: PRODUCT_TYPES.CAR;
	pickUpLocation: string | null;
	dropOffLocation: string | null;
	pickUpDateTime: DateTime<true>;
	dropOffDateTime: DateTime<true>;
}
